﻿export default function formatYAxisLabel(value) {
    try {
        const numberFormatter = new Intl.NumberFormat("da-DK", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        return numberFormatter.format(value);
    } catch (error) {
        console.warn("YAxis formatting failed:", error);
        return String(value ?? "");
    }
}